module.exports = __webpack_public_path__ + "static/media/exhibition_entrance.e852d70e.png";